<template>
  <el-table-column align="center" label="白名单歌单信息">
    <el-table-column label="歌单ID" width="120" prop="tracklistId"></el-table-column>
    <el-table-column label="歌曲&视频信息" width="310" v-slot="{ row }">
      <track-info-mod :data="row"></track-info-mod>
    </el-table-column>
    <el-table-column label="原作品歌曲&视频信息" width="310" v-slot="{ row }">
      <track-info-mod :data="row.originInfo"></track-info-mod>
    </el-table-column>
    <el-table-column label="权利文件" width="85" v-slot="{ row }" show-overflow-tooltip>
      <a v-if="row.rightFile" :href="$toPreview(row.rightFile.fileUrl)" target="_blank">{{ row.rightFile.fileName }}</a>
      <template v-else>-</template>
    </el-table-column>
  </el-table-column>
</template>

<script>
import TrackInfoMod from './TrackInfoMod.vue'

export default {
  name: 'WhiteListInfoCol',
  components: {
    TrackInfoMod
  },
  props: {
  }
}
</script>
